module.exports = __webpack_public_path__ + "static/bf-yoox-88a6412419f3d7e7e5d59511d413d80f.jpg";